const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

const colors = ['#f7ea48', '#ff6b6b', '#63d7c6', '#ffffff', '#9a7cff'];
let canvas;
let context;
let particles = [];
let animationFrame;

const resizeCanvas = () => {
    const pixelRatio = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = window.innerWidth * pixelRatio;
    canvas.height = window.innerHeight * pixelRatio;
    canvas.style.width = `${window.innerWidth}px`;
    canvas.style.height = `${window.innerHeight}px`;
    context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
};

const getCanvas = () => {
    if (canvas) return;

    canvas = document.createElement('canvas');
    canvas.className = 'cta-confetti';
    canvas.setAttribute('aria-hidden', 'true');
    context = canvas.getContext('2d');
    document.body.appendChild(canvas);
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas, { passive: true });
};

const draw = () => {
    if (reduceMotion.matches) particles = [];
    const now = performance.now();
    particles = particles.filter((particle) => !particle.expiresAt || particle.expiresAt > now);

    context.clearRect(0, 0, window.innerWidth, window.innerHeight);

    particles.forEach((particle) => {
        particle.x += particle.velocityX;
        particle.y += particle.velocityY;
        particle.velocityY += 0.16;
        particle.velocityX *= 0.995;
        particle.rotation += particle.rotationSpeed;
        particle.life -= 1;

        context.save();
        context.translate(particle.x, particle.y);
        context.rotate(particle.rotation);
        context.globalAlpha = Math.min(1, particle.life / 25,
            particle.expiresAt ? (particle.expiresAt - now) / 500 : 1);
        context.fillStyle = particle.color;
        context.fillRect(-particle.width / 2, -particle.height / 2, particle.width, particle.height);
        context.restore();
    });

    particles = particles.filter((particle) => particle.life > 0 && particle.y < window.innerHeight + 30);

    if (particles.length) {
        animationFrame = requestAnimationFrame(draw);
    } else {
        cancelAnimationFrame(animationFrame);
        animationFrame = null;
        context.clearRect(0, 0, window.innerWidth, window.innerHeight);
    }
};

export function burstConfetti(element) {
    const bounds = element.getBoundingClientRect();
    burstAt(bounds.left + bounds.width / 2, bounds.top + bounds.height / 2);
}

function burstAt(originX, originY, expiresAt) {
    if (reduceMotion.matches) return;

    getCanvas();

    particles.push(...Array.from({ length: 140 }, () => {
        const angle = Math.random() * Math.PI * 2;
        const speed = 5 + Math.random() * 13;

        return {
            x: originX,
            y: originY,
            velocityX: Math.cos(angle) * speed,
            velocityY: Math.sin(angle) * speed - 5,
            width: 5 + Math.random() * 7,
            height: 3 + Math.random() * 5,
            color: colors[Math.floor(Math.random() * colors.length)],
            rotation: Math.random() * Math.PI,
            rotationSpeed: (Math.random() - 0.5) * 0.35,
            life: 90 + Math.random() * 50,
            expiresAt,
        };
    }));

    if (!animationFrame) animationFrame = requestAnimationFrame(draw);
}

export function thankYouConfetti() {
    if (!document.body.classList.contains('page-id-655') || reduceMotion.matches) return;

    const expiresAt = performance.now() + 3000;
    const burst = () => {
        if (performance.now() < expiresAt - 500) {
            burstAt(window.innerWidth * (0.25 + Math.random() * 0.5),
                window.innerHeight * 0.55, expiresAt);
        }
    };
    burst();
    const interval = setInterval(burst, 650);
    const cleanup = () => {
        clearInterval(interval);
        clearTimeout(timeout);
        particles = particles.filter((particle) => particle.expiresAt !== expiresAt);
        context.clearRect(0, 0, window.innerWidth, window.innerHeight);
        window.removeEventListener('pagehide', cleanup);
        reduceMotion.removeEventListener('change', cleanup);
    };
    const timeout = setTimeout(cleanup, 3000);
    window.addEventListener('pagehide', cleanup);
    reduceMotion.addEventListener('change', cleanup);
}

export function ctaConfetti() {
    document.querySelectorAll('.cta__button').forEach((button) => {
        button.addEventListener('mouseenter', () => burstConfetti(button));
    });
}
